<div class="update-snackbar-content">
  @if (data.kind === "update") {
    <mat-icon class="update-snackbar-icon" aria-hidden="true">
      system_update_alt
    </mat-icon>
  } @else {
    <mat-icon class="update-snackbar-icon" aria-hidden="true">
      wifi_off
    </mat-icon>
  }
  <span>{{ data.message }}</span>
  <button type="button" (click)="onAction()">{{ data.actionLabel }}</button>
</div>
